export const Categories = [
  "unknown",
  "prediction",
  "botnet",
  "ransomware",
  "malicious",
  "malware",
  "phishing",
  "phish",
  "spam",
  "exploit_kit",
  "scanner",
  "suspicious",
  "backscatter",
  "bruteforce",
  "ssh_bf",
  "ssh_bruteforce",
  "mixed",
  "proxy",
  "tor",
  "tor_list",
  "adware",
  "bot",
  "ddos",
  "dyndns",
  "defacement",
]

export const categoryIndex = (category) => Categories.indexOf(category)
